import React from 'react';
import { Button as NativeButton } from '@headlessui/react';
import { cn } from '../../../utils/cn';
import { useTranslation } from 'react-i18next';

function Button({
  variant = 'primary',
  label = '',
  children,
  type = 'button',
  leftIcon,
  rightIcon,
  disabled = false,
  className,
  ...props
}) {
  const { t } = useTranslation();
  const styles = {
    primary: 'bg-accent-orange text-important-foreground',
    secondary:
      'bg-button-secondary border border-accent-orange text-accent-orange',
    accent: 'bg-accent-orange text-important-foreground',
    tertiary: 'bg-accent-blue text-important-foreground'
  };
  const currentStyle = styles[variant] || styles.primary;
  const hasIcon = leftIcon || rightIcon;
  return (
    <NativeButton
      className={cn(
        `${currentStyle} h-12 w-full text-sm font-bold rounded-2 px-4 py-2 flex justify-center items-center gap-2 sm:w-fit sm:min-w-50`,
        className
      )}
      disabled={disabled}
      type={type}
      {...props}
    >
      {hasIcon && <span className='h-6 w-6'>{leftIcon}</span>}
      <span className='flex-grow text-center'>
        {label ? t(label) : children}
      </span>
      {hasIcon && <span className='h-6 w-6'>{rightIcon}</span>}
    </NativeButton>
  );
}

export default Button;
